// @flow
import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllPegawai(params: any): any {
    const baseUrl = '/api/admin/pegawais';
    return api.get(`${baseUrl}`, params);
}
function ApiPostPegawai(params: any): any {
    const baseUrl = '/user/pegawais';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
function ApiEditPasswordPegawai(params: any, id: any): any {
    const baseUrl = '/api/admin/department/' + id;
    return api.update(`${baseUrl}`, params);
}

export { ApiGetAllPegawai, ApiPostPegawai, ApiEditPasswordPegawai };
